export const API_ENDPOINTS = {
  content: "/api/content.php",
  uploadMedia: "/api/upload-media.php",
  visitors: "/api/visitors.php",
  visitorsClear: "/api/visitors.php?action=clear",
  contact: "/api/contact.php",
  contactList: "/api/contact.php?action=list",
  contactMarkRead: "/api/contact.php?action=mark-read",
  contactDelete: "/api/contact.php?action=delete",
  health: "/api/health.php",
} as const;
